"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var components_1 = require("./components");
var ui_1 = require("@vidazoo/ui");
var theme = require("../../styles/baseForm.scss");
var ProfileStore_1 = require("../../stores/ProfileStore");
var BaseContainer_1 = require("../BaseContainer");
var utils_1 = require("@vidazoo/ui/lib/components/utils");
var Profile = /** @class */ (function (_super) {
    tslib_1.__extends(Profile, _super);
    function Profile(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onProfileChange = function (key, value) {
            _this.store.updateParam(key, value);
        };
        _this.enableTwoFactoAuth = function (token) {
            _this.store.enableTwoFactoAuth(token);
        };
        _this.disableTwoFactorAuth = function (password) {
            _this.store.disableTwoFactorAuth(password);
        };
        _this.submit = function () {
            _this.store.submit();
        };
        _this.close = function () {
            var onClose = _this.props.onClose;
            _this.store.close();
            onClose && onClose();
        };
        _this.genereateTwoFactorSecret = function (password) {
            _this.store.genereateTwoFactorSecret(password);
        };
        _this.store = props.profileStore || new ProfileStore_1.default(_this.props.notificationStore);
        return _this;
    }
    Object.defineProperty(Profile.prototype, "isOpen", {
        get: function () {
            // backward compatibility for old method
            return utils_1.isDefined(this.props.isOpen)
                ? this.props.isOpen
                : this.store.isOpen;
        },
        enumerable: true,
        configurable: true
    });
    Profile.prototype.componentDidUpdate = function (prevProps) {
        if (!this.props.profileStore) {
            if (this.props.isOpen && !prevProps.isOpen) {
                this.store.getItem();
            }
        }
    };
    Profile.prototype.renderProfileForm = function () {
        return (React.createElement(components_1.ProfileForm, { firstName: this.store.item.firstName, lastName: this.store.item.lastName, email: this.store.item.email, avatarUrl: this.store.avatarUrl, onChange: this.onProfileChange, onUpdate: this.submit, onCancel: this.close, phone: this.store.item.phone, isVidazooOrganization: this.props.isVidazooOrganization }));
    };
    Profile.prototype.renderTwoFactorForm = function () {
        return (React.createElement(components_1.TwoFaForm, { enableTwoFactoAuth: this.enableTwoFactoAuth, dataUrl: this.store.dataUrl, genereateTwoFactorSecret: this.genereateTwoFactorSecret, disableTwoFactorAuth: this.disableTwoFactorAuth, twoFactorAuth: this.store.item.twoFactorAuth, onCancel: this.close }));
    };
    Profile.prototype.renderPasswordForm = function () {
        var _a = this.store, updatePassword = _a.updatePassword, isCheckingPassword = _a.isCheckingPassword, passwordScore = _a.passwordScore, checkPassword = _a.checkPassword;
        return (React.createElement(components_1.PasswordForm, { checkPassword: checkPassword, passwordScore: passwordScore, isCheckingPassword: isCheckingPassword, onUpdate: updatePassword, onCancel: this.close }));
    };
    Profile.prototype.renderTokensForm = function () {
        var _a = this.store, createToken = _a.createToken, isLoadingTokensApi = _a.isLoadingTokensApi, tokensApi = _a.tokensApi, deleteToken = _a.deleteToken, newTokenApi = _a.newTokenApi, clearNewToken = _a.clearNewToken;
        return (React.createElement(components_1.TokensForm, { clearNewToken: clearNewToken, newTokenApi: newTokenApi, deleteToken: deleteToken, tokens: tokensApi, isLoadingTokensApi: isLoadingTokensApi, createToken: createToken }));
    };
    Profile.prototype.renderForm = function () {
        var remove2fa = this.props.remove2fa;
        return (React.createElement(ui_1.TabsPanel, { animate: true, selectedIndex: this.state.selectedIndex, onChange: this.onTabChange, className: theme.midContent },
            React.createElement(ui_1.Tab, { name: "profile", label: "Profile" }, this.renderProfileForm()),
            remove2fa ? null :
                React.createElement(ui_1.Tab, { name: "twoFactorAuthentication", label: "Two-Factor Authentication" }, this.renderTwoFactorForm()),
            React.createElement(ui_1.Tab, { name: "password", label: "Password" }, this.renderPasswordForm()),
            React.createElement(ui_1.Tab, { onClick: this.store.getTokensApi, name: "tokens", label: "Tokens" }, this.renderTokensForm())));
    };
    Profile.prototype.renderLoader = function () {
        return (React.createElement("div", { className: theme.message },
            React.createElement(ui_1.Loader, { size: 1, gray: true, className: theme.loader }),
            React.createElement(ui_1.PageMessage, { small: true, title: "Loading Profile", description: "Please wait..." })));
    };
    Profile.prototype.render = function () {
        return (React.createElement(ui_1.Modal, { basic: true, scrollableContent: false, exitOnClickOutside: false, isOpen: this.isOpen, onClose: this.close, windowStyle: { width: "62rem", overflow: "hidden" } },
            this.isOpen && this.store.isLoading ? this.renderLoader() : null,
            this.isOpen && !this.store.isLoading ? this.renderForm() : null));
    };
    Profile.defaultProps = {};
    return Profile;
}(BaseContainer_1.default));
exports.default = Profile;
